import { createApiClient } from '@parrot/api-client';
import type { Industry, Product, UserProfile } from './types';

/** All product-suite data lives under the platform service. */
const PLATFORM = '/platform/v1';

export interface PlatformApi {
  listProducts: () => Promise<{ products: Product[] }>;
  listIndustries: () => Promise<{ industries: Industry[] }>;
  me: () => Promise<UserProfile>;
}

/**
 * The three authenticated GETs the suite is built from. There's exactly one
 * backend, so the host is taken from `@parrot/api-client`'s default and the
 * `/platform/v1` prefix is baked in — no configuration.
 */
export function createPlatformApi(): PlatformApi {
  const client = createApiClient();
  return {
    listProducts: () => client.get(`${PLATFORM}/products`),
    listIndustries: () => client.get(`${PLATFORM}/industries`),
    me: () => client.get(`${PLATFORM}/auth/me`),
  };
}
